import React from "react";
import { connect } from "react-redux";

import Message from "../Message/Normal";
import MetaMessage from "../Message/Meta";
import ConversationModel from "/app/src/model/Conversation/model";
import ConversationSelector from "/app/src/model/Conversation/selector";
import EmployeeSelector from "/app/src/model/Employee/selector";
import CustomerSelector from "/app/src/model/Customer/selector";

import { Spinner, Bubble, Flex } from "/app/src/component";

import style from "./index.css";

/*
Action possible:
1. Scroll down
2. Keep scroll position
3. Fetch previous messages
State of scrolling when add a new message
1. on bottom: scrollTop == scrollHeigh
    Action: 1
2. on top: scrollTop == 0
    Action: 3
3. in middle: scrollTop
    Action: 1? 2?
*/
class MessageList extends React.Component {
  constructor(props) {
    super(props);
    this._handleScroll = this._handleScroll.bind(this);
    this._scrollDown = this._scrollDown.bind(this);
  }
  _scrollDown() {
    this.body.scrollTop = this.body.scrollHeight;
    this.previousScrollHeight = this.body.scrollHeight;
  }

  _handleScroll() {
    if (this.body.scrollTop === 0) {
      this.props.dispatch(
        ConversationModel.readEntries(this.props.room, this.props.currentSize)
      );
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this._scrollDown();
    }, 100);
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (prevProps.currentSize < this.props.currentSize) {
      return this.body.scrollHeight - this.body.scrollTop;
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // If we change room, set scroll top to bottom, reset constructor
    if (prevProps.room && this.props.room !== prevProps.room) {
      this.body.scrollTop = this.body.scrollHeight;
    } else {
      // some adjustment if there are change of entries size
      if (snapshot !== null) {
        this.body.scrollTop = this.body.scrollHeight - snapshot;
      }
    }
  }

  render() {
    return (
      <div
        onScroll={this._handleScroll}
        className={style.MessageListWrapper + " ScrollBar"}
        ref={(body) => {
          this.body = body;
        }}
      >
        <Flex w="100%" h="80px" center>
          {this.props.fetching && <Spinner />}
        </Flex>
        {this.renderEntries()}
        <Flex w="100%" h="40px" shrink={0} grow={0}>
          {this.props.isTyping && (
            <Bubble
              marginLeft="4%"
              padding="10px 0px 20px 10px"
              wrapperWidth="90px"
            />
          )}
        </Flex>
      </div>
    );
  }

  renderEntries() {
    const currentUserId = this.props.currentUserId;
    const employees = this.props.employees;
    const customerId = this.props.customerId;
    const customer = this.props.customer;

    function getImage(entryCreatorId) {
      if (entryCreatorId === customerId) {
        return CustomerSelector.getImage(customer);
      }
      let employee = employees.get(entryCreatorId);
      if (employee)
        return EmployeeSelector.getImage(employees.get(entryCreatorId));
      return "";
    }
    function getName(entryCreatorId) {
      if (entryCreatorId === customerId) {
        return CustomerSelector.getName(customer);
      }
      let employee = employees.get(entryCreatorId);
      if (employee) return EmployeeSelector.getName(employee);
      return "";
    }

    // create message from server, either normal or meta
    function craftServerMessage(previousEntry, currentEntry, nextEntry) {
      function getPosition(previousEntry, currentEntry, nextEntry) {
        let currentId = currentEntry.creator_id;
        let position = "middle";

        let previousId = previousEntry ? previousEntry.creator_id : false;
        let nextId = nextEntry ? nextEntry.creator_id : false;
        let nextEntryMeta = nextEntry ? nextEntry.meta : false;
        let previousEntryMeta = previousEntry ? previousEntry.meta : false;

        if (!previousId) {
          if (nextEntryMeta) return "single";
          if (!nextId) return "single";
          if (nextId !== currentId) return "single";
          return "top";
        }
        if (!nextId) {
          if (previousEntryMeta) return "single";
          if (previousId !== currentId) return "single";
          return "bottom";
        }

        if (previousEntryMeta && nextEntryMeta) {
          return "single";
        } else if (previousEntryMeta) {
          if (currentId !== nextId) return "single";
          return "top";
        } else if (nextEntryMeta) {
          if (currentId !== previousId) return "single";
          return "bottom";
        }
        if (currentId !== previousId) {
          position = "top";
          if (currentId !== nextId) {
            position = "single";
          }
        } else if (currentId !== nextId) {
          position = "bottom";
        }
        return position;
      }
      function getDirection(entryCreatorId) {
        if (currentUserId !== entryCreatorId) {
          return "left";
        }
        return "right";
      }

      let message, name, image;

      if (currentEntry.meta) {
        name = getName(currentEntry.creator_id);
        image = getImage(currentEntry.creator_id);
        message = (
          <MetaMessage
            key={"meta" + i}
            entry={currentEntry}
            name={name}
            image={image}
          />
        );
      } else {
        let position = getPosition(previousEntry, currentEntry, nextEntry);
        let direction = getDirection(currentEntry.creator_id);
        if (direction === "left") {
          if (position === "top" || position === "single") {
            name = getName(currentEntry.creator_id);
          }
          if (position === "bottom" || position === "single") {
            image = getImage(currentEntry.creator_id);
          }
        }
        message = (
          <Message
            key={"confirmed" + i}
            entry={currentEntry}
            direction={direction}
            position={position}
            name={name}
            image={image}
          />
        );
      }
      return message;
    }

    // push message if exist
    function pushMessage(key, entriesComponent, message) {
      if (message)
        entriesComponent.push(
          <Flex shrink={0} key={key} width="100%" hAlignContent="center">
            {message}
          </Flex>
        );
    }

    let entries = this.props.confirmed.toJS();
    let entriesComponent = [];

    for (var i = 0; i < entries.length; i++) {
      // prework to get the variables setup
      let previousEntry = entries[i - 1];
      let currentEntry = entries[i];
      let nextEntry = entries[i + 1];

      let serverMessage = craftServerMessage(
        previousEntry,
        currentEntry,
        nextEntry
      );
      pushMessage("server" + i, entriesComponent, serverMessage);
    }

    const read = this.props.read.toJS();
    const readPositions = {};
    for (var r in read) {
      if (Number(r) === this.props.currentUserId) continue;
      if (!readPositions[read[r]]) {
        readPositions[read[r]] = [];
      }
      readPositions[read[r]].push(parseInt(r, 10));
    }
    for (var rp in readPositions) {
      let pos = entries.length - parseInt(rp, 10);
      if (pos < 1) continue; // prevent read from 0
      entriesComponent.splice(
        pos,
        0,
        <Flex key={"read-" + pos} hAlignContent="right" shrink={0} column>
          <Flex color="darkgrey" fontSize="12px" hAlignContent="right">
            Läst av
          </Flex>
          <Flex hAlignContent="right">
            {readPositions[rp].map((participant, index) => {
              if (!getImage(participant)) return null;
              if (participant === this.props.currentUserId) return null;
              return (
                <Flex
                  key={"read-participant" + index}
                  marginLeft="10px"
                  marginBottom="10px"
                  borderRadius="50%"
                  overflow="hidden"
                >
                  <img
                    title={"Läst av " + getName(participant)}
                    height="20px"
                    width="20px"
                    src={getImage(participant)}
                    alt=""
                  />
                </Flex>
              );
            })}
          </Flex>
        </Flex>
      );
    }
    return entriesComponent;
  }
}

function matchStateToProps(state, ownProps) {
  var room = ownProps.room;
  var conversation = ConversationSelector.getByRoom(state, room);
  var conversationType = ConversationSelector.getType(conversation);

  var customerId = ConversationSelector.getCustomerId(conversation, 0);
  var customer = CustomerSelector.getById(state, customerId);

  var confirmed = ConversationSelector.getConfirmedEntries(conversation);
  var unconfirmed = ConversationSelector.getUnconfirmedEntries(conversation);
  var read = ConversationSelector.getRead(conversation);

  return {
    customerId: customerId,
    customer: customer,
    employees: EmployeeSelector.getAll(state),
    assigned: ConversationSelector.getAssignedEmployee(conversation),
    conversation: conversation,
    conversationType: conversationType,
    confirmed: confirmed,
    unconfirmed: unconfirmed,
    fetching: state.getIn([
      "conversation",
      "items",
      room,
      "entries",
      "fetching",
    ]),
    fetched: state.getIn(["conversation", "items", room, "entries", "fetched"]),
    currentSize: conversation.getIn(["entries", "confirmed"]).size,
    currentUserId: state.getIn(["user", "login", "id"]),
    read: read,
  };
}

export default connect(matchStateToProps)(MessageList);



// WEBPACK FOOTER //
// ./src/component/Conversation/MessagesList/index.js